import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LocationEdit from "./LocationEdit";
import LocationShow from "./LocationShow";
import LocationsList from "./LocationsList";
import LocationCreate from "./LocationCreate";

export const locations = {
  list: LocationsList,
  show: LocationShow,
  edit: LocationEdit,
  create: LocationCreate,
  icon: LocationOnOutlinedIcon,
  options: { label: "Gestion des locations" },
};
